export default __webpack_public_path__ + "0c72a1e5086aa3e289776f036bbf09da.png";